//* Faq question and answer filter btn function

class FaqFilter {
  constructor() {
    this.filterButtons = $(".c-faq-filter-button");
    this.faqItems = $(".c-faq--container");
    this.activeFilter = null; // only one filter active at a time
    this.init();
  }

  init() {
    this.filterButtons.siblings('[data-key=view_all]').addClass("c-faq-filter-button--active");
    this.filterButtons.on("click", (event) =>
      this.toggleFilter(event.currentTarget)
    );
  }

  toggleFilter(button) {
    const $button = $(button);
    const filterKey = $button.data("key");

    console.log(filterKey);
    console.log(this.activeFilter);
    console.log(this.filterButtons);

    if(filterKey === 'view_all') {
      this.activeFilter = null;
      this.filterButtons.removeClass("c-faq-filter-button--active");
      $button.addClass("c-faq-filter-button--active");
    }
    else {
      // If the clicked button is already active, remove filter
      if (this.activeFilter === filterKey) {
        this.activeFilter = null;
        this.filterButtons.removeClass("c-faq-filter-button--active");
        this.filterButtons.siblings('[data-key=view_all]').addClass("c-faq-filter-button--active");
      } else {
        this.activeFilter = filterKey;
        this.filterButtons.removeClass("c-faq-filter-button--active");
        $button.addClass("c-faq-filter-button--active");
      }
    }

    this.filterFaqs();
  }

  filterFaqs() {
    if (!this.activeFilter) {
      this.faqItems.removeClass("c-hidden");
      return;
    }

    this.faqItems.each((_, item) => {
      const $item = $(item);
      const itemFilters = $item.data("key");

      $item.toggleClass(
        "c-hidden",
        !itemFilters.includes(this.activeFilter)
      );
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new FaqFilter();
});